import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) return navigate("/auth", { replace: true });
    api
      .get(`/auth/google/session`, { params: { session_id: sessionId } })
      .then(({ data }) => {
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        navigate(data.role ? "/dashboard" : "/auth/complete", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <p className="overline-label">Signing you in…</p>
    </div>
  );
}
